import React, { FormEvent } from 'react';
import { useUpdateChartSection } from '../../hooks/useUpdateChartSection';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Button } from '../buttons/Button';
import { CheckoutFormProps } from '../../types/Payment/CheckoutFormProps';
import * as Sentry from '@sentry/browser';

export const CheckoutForm = (props: CheckoutFormProps) => {
  const stripe = useStripe();
  const elements = useElements();
  const { mutate: updateChart } = useUpdateChartSection();

  const handleFirestoreUpdate = () => {
    updateChart(
      {
        patientId: props.patientId,
        docData: {
          PAYMENT_INFO: {
            alreadyPaid: true,
            amountPaid: props.amountPaid,
            couponCode: props.couponCode,
            discountApplied: props.discountApplied,
          },
        },
      },
      {
        onSuccess: () => {
          // alert("Successfully updated document");
        },
        onError: (error) => {
          Sentry.captureException(error);
          alert(`Error updating document: ${error.message}`); // TELL THE USER
          console.error(error); // GET THE STACKTRACE
        },
      },
    );
  };

  const [errorMessage, setErrorMessage] = React.useState('');

  const handleSubmit = async (event: FormEvent) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const { error } = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        //TODO: UPDATE THIS URL TO REDIRECT TO MEDICARE/INSURANCE IF NECESSARY
        return_url: `${import.meta.env.VITE_PORTAL_BASE_URL}/${props.patientId}/payment/thanks`,
      },
    });

    if (error) {
      Sentry.captureException(error);
      // This point will only be reached if there is an immediate error when confirming the payment. Show error to your customer (for example, payment details incomplete)
      if (error.message) {
        setErrorMessage(error.message);
      }
    } else {
      // Your customer will be redirected to your `return_url`. For some payment methods like iDEAL, your customer will be redirected to an intermediate site first to authorize the payment, then redirected to the `return_url`.
      console.info('Payment succeeded. Updating Firestore...');
      handleFirestoreUpdate();
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <Button
        id="submit-payment"
        type="submit"
        textContent="Submit Payment"
        disabled={!stripe}
        onClick={handleSubmit}
      />
      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
    </form>
  );
};
